import React from 'react'
import classNames from 'classnames'
import { NavLink } from 'react-router-dom'
import { Header } from '@crossfit/ui'

import InnerContent from 'components/InnerContent'
import type { NavLinkProps } from 'react-router-dom'

import style from './style.module.css'
import { trackEvent } from 'services/segment'
import { useSelector } from 'react-redux'
import { getMyAffiliates } from 'store/selectors'

export function BackLinkMobile(props: NavLinkProps) {
  return (
    <NavLink className={classNames(style.backLink, style.mobile)} {...props} />
  )
}

export function BackLinkDesktop(props: NavLinkProps) {
  return (
    <NavLink className={classNames(style.backLink, style.desktop)} {...props} />
  )
}

type TitleProps = {
  children: React.ReactNode
  previousTo?: string
  nextTo?: string
}

export function Title({ children, previousTo, nextTo }: TitleProps) {
  const url = window.location.href
  const title = document.title
  const path = window.location.pathname
  const { selectedAffiliate } = useSelector(getMyAffiliates)
  return (
    <div className={style.titleWrapper}>
      <Header size='medium' className={style.title}>
        {children}
      </Header>

      {previousTo ? (
        <NavLink
          to={previousTo}
          className={style.previousLink}
          aria-label='Previous'
          onClick={() => {
            trackEvent({
              component: 'Programming Date Selector',
              event: 'Programming Date Selector Clicked',
              location: 'Affiliate Toolkit',
              text: 'Previous',
              linkUrl: previousTo,
              affiliateId: selectedAffiliate?.affiliateId,
              userRole:
                selectedAffiliate?.roles?.length > 0
                  ? selectedAffiliate?.roles[0]
                  : null,
              groupId: selectedAffiliate?.groupId,
              context: {
                page: {
                  url,
                  title,
                  path,
                },
              },
            })
          }}
        >
          Previous
        </NavLink>
      ) : (
        <div className={classNames(style.previousLink, style.disabled)} />
      )}
      {nextTo ? (
        <NavLink
          to={nextTo}
          className={style.nextLink}
          aria-label='Next'
          onClick={() => {
            trackEvent({
              component: 'Programming Date Selector',
              event: 'Programming Date Selector Clicked',
              location: 'Affiliate Toolkit',
              text: 'Next',
              linkUrl: nextTo,
              affiliateId: selectedAffiliate?.affiliateId,
              userRole:
                selectedAffiliate?.roles?.length > 0
                  ? selectedAffiliate?.roles[0]
                  : null,
              groupId: selectedAffiliate?.groupId,
              context: {
                page: {
                  url,
                  title,
                  path,
                },
              },
            })
          }}
        >
          Next
        </NavLink>
      ) : (
        <div className={classNames(style.nextLink, style.disabled)} />
      )}
    </div>
  )
}

type WrapperProps = {
  children: React.ReactNode
  backLinkTo?: string
}

export function Wrapper({ children, backLinkTo }: WrapperProps) {
  return (
    <>
      <div className={style.wrapper}>
        <InnerContent variant='xlarge' className={style.wrapperInnerContent}>
          {backLinkTo && (
            <BackLinkDesktop to={backLinkTo}>
              Return to week view
            </BackLinkDesktop>
          )}
          {children}
        </InnerContent>
      </div>

      {backLinkTo && (
        <InnerContent variant='xlarge' className={style.mobileBackLinkWrapper}>
          <BackLinkMobile to={backLinkTo}>Return to week view</BackLinkMobile>
        </InnerContent>
      )}
    </>
  )
}
